import { Button, Logo } from 'components';
import { DesktopNavContainer, NavContact } from './styles';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { useCallback } from 'react';

export const Navbar = () => {
  const { t } = useTranslation('common');

  const handleOpenPdf = useCallback(() => {
    window.open('./cv/NadinePesso__CV__Ed&Tech_v2.pdf', '_blank');
  }, []);

  return (
    <DesktopNavContainer>
      <Link href='/#home' passHref>
        <Logo />
      </Link>
      <NavContact>
        <Button label={t('BUTTONS.CV')} onClick={handleOpenPdf} />
      </NavContact>
    </DesktopNavContainer>
  );
};
